/**
 * Thumbnail grid for an expanded alert gallery. Renders existing photos
 * plus an "Add" tile when the caller is allowed to upload more.
 */
export default function AlertImageThumbs({ alertId, images, canAdd, onOpenLightbox, onShowAdder }) {
  return (
    <div className="flex flex-wrap gap-1.5">
      {images.map((src, idx) => (
        <button
          type="button"
          key={`${idx}-${src.slice(-24)}`}
          onClick={() => onOpenLightbox(idx)}
          className="w-16 h-16 rounded-sm overflow-hidden border border-gray-200 bg-gray-50 hover:opacity-90 transition-opacity"
          data-testid={`alert-thumb-${alertId}-${idx}`}
        >
          <img src={src} alt={`Photo ${idx + 1}`} className="w-full h-full object-cover" />
        </button>
      ))}
      {canAdd && (
        <button
          type="button"
          onClick={onShowAdder}
          className="w-16 h-16 rounded-sm border-2 border-dashed border-gray-300 hover:border-gray-500 text-gray-500 hover:text-gray-700 flex items-center justify-center text-[10px] font-body"
          data-testid={`alert-gallery-add-${alertId}`}
          title="Add a photo"
        >
          +
        </button>
      )}
    </div>
  );
}
